module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interior-view",
    attrs: {
      "id": "documentsSets"
    }
  }, [(_vm.invitations.length) ? _c('section', {
    staticClass: "invitations"
  }, [_c('div', [_c('h3', [_vm._v("Invitations")]), _vm._v(" "), _vm._l((_vm.invitations), function(invitation) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-8 text-left invitation-title"
    }, [_vm._v(_vm._s(invitation.documentSet.fullName))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 text-right"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.handleInvitation(invitation, 'accepted')
        }
      }
    }, [_vm._v("Accept")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.handleInvitation(invitation, 'declined')
        }
      }
    }, [_vm._v("Decline")])])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.documentSetsExist) ? _c('section', {
    staticClass: "document-sets clearfix"
  }, [(_vm.store.data.documentSets.ownedSets.length) ? _c('div', [_c('h3', [_vm._v("My Documents")]), _vm._v(" "), _vm._l((_vm.store.data.documentSets.ownedSets), function(set) {
    return _c('p', [_c('router-link', {
      staticClass: "btn btn-wide btn-document-set",
      attrs: {
        "to": '/documents-view/owneddocumentsets/' + set.id
      }
    }, [_vm._v(_vm._s(set.name))])], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.store.data.documentSets.sharedSets.length) ? _c('div', [_c('h3', [_vm._v("Documents Shared With Me")]), _vm._v(" "), _vm._l((_vm.store.data.documentSets.sharedSets), function(set) {
    return _c('p', [_c('router-link', {
      staticClass: "btn btn-wide btn-document-set",
      attrs: {
        "to": '/documents-view/shareddocumentsets/' + set.id
      }
    }, [_vm._l((set.owners), function(owner) {
      return _c('div', [_vm._v(_vm._s(owner.user.firstName) + " " + _vm._s(owner.user.lastName))])
    }), _vm._v(" "), _c('div', {
      staticClass: "set-title"
    }, [_vm._v(_vm._s(set.name))])], 2)], 1)
  })], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fdf8205"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentSets.vue
// module id = 283
// module chunks = 1